import { render } from "./TheMyCollectionHeader.vue?vue&type=template&id=89d0600c&scoped=true&ts=true"
import script from "./TheMyCollectionHeader.vue?vue&type=script&lang=ts"
export * from "./TheMyCollectionHeader.vue?vue&type=script&lang=ts"

import "./TheMyCollectionHeader.vue?vue&type=style&index=0&id=89d0600c&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src245414373/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-89d0600c"]])

export default __exports__